var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSlower = function SvgSlower(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "slower_svg__Zeichenfl\\xE4che_1_1_",
    x: 0,
    y: 0,
    viewBox: "0 0 3971 4175",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".slower_svg__slower0{opacity:.99;fill:none;stroke:#575d6b;stroke-width:358;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "slower_svg__Form_1_xA0_Bild_1_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3736.6 692 2029.8 2398.9 352.5 721.6",
    className: "slower_svg__slower0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3735.5 1784.1 2028.7 3490.9 351.4 1813.6",
    className: "slower_svg__slower0"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSlower);
export default ForwardRef;